import { Breadcrumb, Form, Row, Select, Space, Steps } from 'antd';
import { BaseEntityFieldValidator, BranchValidator, PosValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { generalCreators } from '../../../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../../../redux/general/general-reducer';
import RBHBox from '../../../../../../shared/components/rbh-box';
import RBHButton from '../../../../../../shared/components/rbh-button';
import RBHSelect from '../../../../../../shared/components/rbh-select';
import RBHSteps from '../../../../../../shared/components/rbh-steps';
import RBHText from '../../../../../../shared/components/rbh-text';
import styleText from '../../../../../../shared/components/rbh-text/styles';
import RBHTextInput from '../../../../../../shared/components/rbh-textinput';
import { Branch } from '../../../../../../shared/models/branch';
import { PosProvider } from '../../../../../../shared/models/pos-provider';
import { mainCreators } from '../../../../../main-action';
import { MAIN_STATE_KEY } from '../../../../../main-reducer';
import { BUTTON_FLAG, POS_REQUEST_ID_LIST } from '../../redux/pos-constant';
import { POS_STATE_KEY, posStateSelector } from '../../redux/pos-reducer';
import { posSagas } from '../../redux/pos-saga';
import { PosService } from '../../redux/pos-service';
import styles, { layout } from '../styles';
import { posCreators } from '../../redux/pos-action';
import { RBHAlert } from '../../../../../../shared/components';

export const PosStep3Screen: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(true);
  const shopData = useSelector(posStateSelector(POS_STATE_KEY.POS_SHOP_DATA)) as Branch;
  const prefilledFormValue = useSelector(posStateSelector(POS_STATE_KEY.PREFILLED_FORM_STEP_3));
  const [posProvider, setPosProvider] = useState<PosProvider[]>([]);
  const [prefilledPosProvider, setPrefilledPosProvider] = useState<any>();
  const [formInvalid, setFormInvalid] = useState<boolean>(true);
  const alertSuccess = useSelector(posStateSelector(POS_STATE_KEY.ALERT_SUCCESS));

  const toPath = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push(path);
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (key === 'shopId' || key === 'providerId') {
        if (!!!values[key]) {
          invalid = true;
          break;
        }
      } else {
        if (!!!values[key] || !BaseEntityFieldValidator.genericTextInputRegexPattern.test(values[key])) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const validatePrefilledValue = (values: any) => {
    let invalid = false;
    if (!!!values?.shopId || !!!values?.providerId || !!!values?.branchCode || !!!values?.posReferenceId ||
      !BaseEntityFieldValidator.genericTextInputRegexPattern.test(values?.branchCode) ||
      !BaseEntityFieldValidator.genericTextInputRegexPattern.test(values?.posReferenceId)) {
      invalid = true;
    }
    setFormInvalid(invalid);
  };

  // pass this function because set state in reducer is not working on first render
  const setAndPrefillValues = (list: PosProvider[], values?: any) => {
    setPosProvider(list);
    // when reload form value does not change
    if (!!values) {
      form.resetFields();
      form.setFieldsValue(values);
      return;
    }
    // back to previous, used remembered prefill before leaving screen
    if (!!prefilledFormValue) {
      form.resetFields();
      let selectedProvider;
      if (prefilledFormValue?.providerId) {
        selectedProvider = list.find((value: PosProvider) => value.providerId === prefilledFormValue?.providerId);
      }
      form.setFieldsValue(prefilledFormValue);
      setPrefilledPosProvider(selectedProvider);
      validatePrefilledValue({ ...prefilledFormValue, providerId: selectedProvider?.providerId });
      setLoading(false);
      return;
    }
    // prefill initial value from pos management
    if (!!!values && !!shopData) {
      const selectedProvider = list.find((value: PosProvider) => value.providerId === shopData?.provider?.providerId);
      setPrefilledPosProvider(selectedProvider);
      validatePrefilledValue({
        shopId: shopData?.shopId,
        branchCode: shopData?.branchCode,
        posReferenceId: shopData?.posReferenceId,
        providerId: selectedProvider?.providerId
      });
      setLoading(false);
      return;
    }
    setLoading(false);
  };

  const getPosProvider = (values?: any) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(httpCreators.request({
      service: PosService.getPosProvider,
      sagaHandler: posSagas.getPosProviderHandler,
      id: POS_REQUEST_ID_LIST.GET_POS_PROVIDER,
      callbackParams: { setAndPrefillValues, values, getPosProvider }
    }));
  };

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    if (!!!shopData) {
      toPath('/main/posmanagement');
    } else {
      getPosProvider();
    }
  }, []);

  useEffect(() => {
    // validate prefilled special characters
    if (!!!prefilledFormValue) {
      setTimeout(() => {
        if (!!shopData?.branchCode) {
          form.validateFields(['branchCode']);
        }
        if (!!shopData?.posReferenceId) {
          form.validateFields(['posReferenceId']);
        }
      }, 500);
    }
  }, [prefilledFormValue]);

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const updatePos = (body: any, pathName?: string, values?: any) => {
    dispatch(httpCreators.request({
      service: PosService.updatePos,
      sagaHandler: posSagas.updatePosStep3Handler,
      id: POS_REQUEST_ID_LIST.PATCH_UPDATE_POS,
      callbackParams: { history, pathName, getPosProvider, values },
      serviceParams: body
    }));
  };

  const handleButtonCall = (buttonFlag: string, path?: string) => {
    let body;
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
    if (buttonFlag === BUTTON_FLAG.BACK_ONLY) {
      body = { shopId: shopData?.shopId, buttonFlag };
      updatePos(body, path, prefilledFormValue);
    } else {
      const error = form.getFieldsError();
      const foundError = error.find((e: any) => e.errors[0]?.props?.id === 'main.form.text.valid');
      if (!!foundError) {
        form.scrollToField(foundError.name[0], { behavior: 'smooth' });
      } else {
        // buttonFlag = 1 (SAVE_ONLY), buttonFlag = 0 (BACK_AND_SAVE)
        const values = form.getFieldsValue();
        body = { ...values, buttonFlag };
        updatePos(body, path, values);
      }
    }
  };

  const postMhStatus = () => {
    const body = form.getFieldsValue();
    dispatch(httpCreators.request({
      service: PosService.postMhStatus,
      sagaHandler: posSagas.postMhStatusHandler,
      id: POS_REQUEST_ID_LIST.POST_MH_STATUS,
      serviceParams: body,
      callbackParams: { history }
    }));
  };

  setTimeout(() => {
    if (alertSuccess) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, false));
    }
  }, 3000);

  const handleSuccessClose = () => {
    dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, false));
  };

  const isAlert = () => {
    if (alertSuccess) {
      return (
        <RBHBox id={'posActivate-alert-step3-success'} data-testid={'posActivate-alert-step3-success'}>
          <RBHAlert type={'success'} text={'main.posManagement.posActivate.step1.alert.success'}
            afterClose={handleSuccessClose} /><br />
        </RBHBox>
      );
    }
  };

  const cancelPos = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalImageId: 'cancelPos-alert-img',
      modalTitle: 'main.posManagement.posActivate.popup.cancelPos.header',
      modalTitleId: 'cancelPos-header-text',
      modalContent: 'main.posManagement.posActivate.popup.cancelPos.content',
      modalContentId: 'cancelPos-content-text',
      onOkText: 'main.posManagement.posActivate.popup.cancelPos.ok',
      onOkTextId: 'cancelPos-ok-text',
      onCancelText: 'main.posManagement.posActivate.popup.cancelPos.cancel',
      onCancelTextId: 'cancelPos-cancel-text',
      onConfirm: () => {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
        dispatch(httpCreators.request({
          id: POS_REQUEST_ID_LIST.PATCH_CANCEL_POS,
          sagaHandler: posSagas.patchCancelPosHandler as any,
          service: PosService.patchCancelPos,
          serviceParams: { shopId: shopData.shopId },
          callbackParams: {
            alertCancelPosSuccess: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS, true)),
            alertCancelPosFail: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL, true)),
            toPath
          },
        }));
      },
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'posmanagement-tohomepage-breadcrumb'}
              id={'posmanagement-tohomepage-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => handleButtonCall(BUTTON_FLAG.SAVE_ONLY, '/main'),
                onLeaveOnly: () => {
                  toPath('/main');
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'branchmanagement-breadcrumb'}
              id={'branchmanagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => handleButtonCall(BUTTON_FLAG.SAVE_ONLY, '/main/branchmanagement'),
                onLeaveOnly: () => {
                  toPath('/main/branchmanagement');
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'posManagement-breadcrumb'}
              id={'posManagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => handleButtonCall(BUTTON_FLAG.SAVE_ONLY, '/main/posmanagement'),
                onLeaveOnly: () => {
                  toPath('/main/posmanagement');
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.posManagement.landing.posManagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'posActivate-breadcrumb'}
              id={'posActivate-breadcrumb'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.posManagement.breadcrumb.activate.pos'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const headerRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={'posActivate-step3-header'} id={'posActivate-step3-header'}
          style={styleText.headerText} text={'main.posManagement.breadcrumb.activate.pos'} />
        <RBHText data-testid={'cancel-posActivate-step3'} id={'cancel-posActivate-step3'}
          style={styles.regularPurple14under} text={'main.posManagement.posActivate.cancelActivatePos'}
          onClick={cancelPos} />
      </RBHBox>
    );
  };

  const posStepText = (step: number) => {
    if (step === 1) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step1-1'} id={'posActivate-step1-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.1'} />
          <RBHText data-testid={'posActivate-step1-2'} id={'posActivate-step1-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.2'} />
        </RBHBox>
      );
    } else if (step === 2) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step2-1'} id={'posActivate-step2-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step2'} />
        </RBHBox>
      );
    } else if (step === 3) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step3-1'} id={'posActivate-step3-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.1'} />
          <RBHText data-testid={'posActivate-step3-2'} id={'posActivate-step3-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.2'} />
        </RBHBox>
      );
    } else if (step === 4) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step4'} id={'posActivate-step4'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step4'} />
        </RBHBox>
      );
    }
  };

  const stepRender = () => {
    const { Step } = Steps;
    return (
      <RBHSteps current={2} type={'default'} className={'posStep'} style={styles.marginBottom20}>
        <Step style={styles.regular16fakeBlack} title={posStepText(1)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(2)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(3)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(4)} />
      </RBHSteps>
    );
  };

  const shopNameAndDescRender = () => {
    return (
      <RBHBox>
        <RBHBox style={{ display: 'flex' }}>
          <RBHText data-testid={'posActivate-shopNameLabel'} id={'posActivate-shopNameLabel'}
            style={styles.medium16fakeBlackTop} text={'main.posManagement.posActivate.shopNameLabel'} />&nbsp;
          <RBHText style={styles.regular16DarkGray}>{shopData?.shopName}</RBHText>
        </RBHBox>
        <RBHBox style={styles.line} />
      </RBHBox>
    );
  };

  const renderContent = () => {
    return (
      <RBHBox style={{ paddingTop: '20px' }}>
        <RBHText data-testid={'contentTitle'} id={'contentTitle'} style={styles.medium16fakeBlack}
          text={'main.posManagement.posActivate.contentTitle'} />
        <RBHText data-testid={'contentDetail'} id={'contentDetail'} style={styles.regular14DarkGray} text={'main.posManagement.posActivate.contentDetail'} />
        <Form
          size={'large'}
          onFieldsChange={checkFormInvalid}
          form={form}
          style={styleText.formText}
          {...layout}>
          <Form.Item
            name={'shopId'}
            colon={false}
            validateTrigger={['onChange', 'onBlur']}
            label={<FormattedMessage id={'main.posManagement.posActivate.shopId'} />}
            initialValue={shopData?.shopId || undefined}
            rules={[
              { required: true, message: <FormattedMessage id={'main.form.required2'} /> }
            ]}>
            <RBHTextInput disabled data-testid={'shopId'} id={'shopId'} placeholder={'main.posManagement.posActivate.shopId'} />
          </Form.Item>
          <Form.Item
            name={'branchCode'}
            colon={false}
            validateTrigger={['onChange', 'onBlur']}
            label={<FormattedMessage id={'main.posManagement.posActivate.shopBranchCode'} />}
            initialValue={shopData?.branchCode || undefined}
            rules={[
              { required: true, message: <FormattedMessage id={'main.form.required2'} /> },
              { pattern: BaseEntityFieldValidator.genericTextInputRegexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> }
            ]}>
            <RBHTextInput onBlur={() => trimFieldValue('branchCode')}
              maxLength={BranchValidator.branchCode.maxLength}
              data-testid={'branchCode'} id={'branchCode'}
              placeholder={'main.posManagement.posActivate.shopBranchCodePlaceholder'} />
          </Form.Item>
          <Form.Item
            name={'providerId'}
            colon={false}
            validateTrigger={['onChange', 'onBlur']}
            label={<FormattedMessage id={'main.posManagement.posActivate.providerName'} />}
            initialValue={prefilledPosProvider?.providerId || undefined}
            rules={[
              { required: true, message: <FormattedMessage id={'main.form.required2'} /> }
            ]}>
            <RBHSelect optionFilterProp={'children'} placeholder={'main.posManagement.posActivate.providerNamePlaceholder'}>
              {posProvider?.length > 0 ? posProvider.map((value: PosProvider) => {
                return (
                  <Select.Option key={value.providerId} value={value.providerId!} style={styleText.textRegular14}
                    title={value.providerName}>{value.providerName}</Select.Option>
                );
              }) : null}
            </RBHSelect>
          </Form.Item>
          <Form.Item
            name={'posReferenceId'}
            colon={false}
            validateTrigger={['onChange', 'onBlur']}
            label={<FormattedMessage id={'main.posManagement.posActivate.posReferenceId'} />}
            initialValue={shopData?.posReferenceId || undefined}
            rules={[
              { required: true, message: <FormattedMessage id={'main.form.required2'} /> },
              { pattern: BaseEntityFieldValidator.genericTextInputRegexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> }
            ]}>
            <RBHTextInput onBlur={() => trimFieldValue('posReferenceId')}
              maxLength={PosValidator.posReferenceId.maxLength}
              data-testid={'posReferenceId'} id={'posReferenceId'}
              placeholder={'main.posManagement.posActivate.posReferenceIdPlaceholder'} />
          </Form.Item>
        </Form>
      </RBHBox>
    );
  };

  const buttonsRender = () => {
    return (
      <RBHBox style={styles.boxButtonStep3}>
        <Row justify={'space-between'} align={'middle'}>
          <RBHButton
            id={'posActivate-buttonBackToPrevious'}
            style={styles.buttonFromCancelGradient}
            type='primary'
            htmlType='button'
            onClick={() => {
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: () => handleButtonCall(BUTTON_FLAG.BACK_AND_SAVE, '/main/posmanagement/step2'),
                onCancel: () => handleButtonCall(BUTTON_FLAG.BACK_ONLY, '/main/posmanagement/step2'),
                type: MODAL_TYPE.BACK_TO_PREVIOUS
              }));
            }}
            text={'main.posManagement.posActivate.buttonBackToPrevious'}
            data-testid={'posActivate-buttonBackToPrevious'} />
          <Space size={'middle'}>
            <RBHButton
              id={'posActivate-buttonSaveOnly'}
              style={styles.buttonFromCancelGradient}
              type='primary'
              htmlType='button'
              onClick={() => handleButtonCall(BUTTON_FLAG.SAVE_ONLY, '/main/posmanagement/step3')}
              text={'main.posManagement.posActivate.buttonSaveOnly'}
              data-testid={'posActivate-buttonSaveOnly'} />
            <RBHButton
              id={'posActivate-buttonSaveAndVerify'}
              style={styles.buttonFromConfirmGradient}
              type='primary'
              htmlType='button'
              onClick={postMhStatus}
              disabled={formInvalid}
              text={'main.posManagement.posActivate.buttonSaveAndVerify'}
              data-testid={'posActivate-buttonSaveAndVerify'} />
          </Space>
        </Row>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      {isAlert()}
      {BreadcrumbRender()}
      <RBHBox>
        {headerRender()}
        {stepRender()}
        {!loading && <RBHBox>
          <RBHBox style={styles.defaultContent}>
            {shopNameAndDescRender()}
            {renderContent()}
          </RBHBox>
          {buttonsRender()}
        </RBHBox>
        }
      </RBHBox>
    </RBHBox>
  );
};
